import {Dispatch, FC, SetStateAction, useEffect} from 'react'
import {Modal} from 'react-bootstrap'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {schemaCECO} from '../../../../../../../../util/validation'
import {createCECO, updateCECO} from '../../../../../../services'
import {CECOModel} from '../../../../../../model'
import {useCentral} from '../../../../../../../../hooks/useCentral'
import {KTSVG} from '../../../../../../../../../../_metronic/helpers'
import {InputText} from '../../../../../../../../components/UI/Input'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  getProflieByUserList: () => void
  setIdPermissionList: () => void
  idPermission?: ''
  detailpermission?: CECOModel
}

const ModalAddCECO: FC<Props> = ({
  show,
  setShow,
  setIdPermissionList,
  getProflieByUserList,
  idPermission,
  detailpermission,
}) => {
  const {currentTabItem} = useCentral()

  const methods = useForm<CECOModel>({
    resolver: yupResolver(schemaCECO),
  })
  const {
    setValue,
    handleSubmit,
    reset,
    register,
    formState: {errors},
  } = methods
  useEffect(() => {
    if (idPermission) {
      setValue('area_Proyecto', detailpermission?.area_Proyecto)
      setValue('centrodecosto', detailpermission?.centrodecosto)
    }
  }, [idPermission])
  const handleClose = () => {
    setShow(false)
    reset()
    setIdPermissionList()
  }

  const onSubmit = async (data: CECOModel) => {
    try {
      if (idPermission) {
        let obj = {
          id: idPermission,
          recepcionadorServicioId: currentTabItem.idToEdit,
          ...data,
        }
        const {data: res} = await updateCECO(obj)
        if (!res.error) {
          handleClose()
          getProflieByUserList()
          //mostrar snackbar
        } else {
        }
      } else {
        let obj = {
          recepcionadorServicioId: currentTabItem.idToEdit,
          ...data,
        }

        const {data: res} = await createCECO(obj)
        if (!res.error) {
          handleClose()
          getProflieByUserList()
        } else {
        }
      }
    } catch (error) {}
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-md'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          {idPermission ? (
            <h5 className='modal-title'>Editar Permiso</h5>
          ) : (
            <h5 className='modal-title'>Agregar Permiso</h5>
          )}
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <FormProvider {...methods}>
            <form>
              <div className='row'>
                <div className='mb-2 col-12'>
                  <label className='required form-label'>Área/Proyecto</label>
                  <InputText
                    name='area_Proyecto'
                    textPlaceholder='Escribe el texto adicional'
                    register={register}
                    errors={errors}
                    maxLength={200}
                  />
                </div>
                <div className='mb-2 col-12'>
                  <label className='required form-label'>Centro de costo</label>
                  <InputText
                    name='centrodecosto'
                    textPlaceholder='Escribe el texto adicional'
                    register={register}
                    errors={errors}
                    maxLength={100}
                  />
                </div>
              </div>
              <div className='d-flex justify-content-center mb-3'>
                <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                  Cancelar
                </button>
                <button type='submit' className='btn btn-primary' onClick={handleSubmit(onSubmit)}>
                  Guardar
                </button>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </Modal>
  )
}

export {ModalAddCECO}
